import { createContext } from "react";
import { iEnquiry } from "../interfaces/iEnquiry";

export const RemoveEnquiriesContext = createContext((enquiries: Array<iEnquiry>) => {});
